import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const PinLocationIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C8.134 2 5 5.134 5 9C5 12.966 9.404 18.82 11.226 21.071C11.626 21.565 12.374 21.565 12.774 21.071C14.596 18.82 19 12.966 19 9C19 5.134 15.866 2 12 2ZM12 11.5C10.619 11.5 9.5 10.381 9.5 9C9.5 7.619 10.619 6.5 12 6.5C13.381 6.5 14.5 7.619 14.5 9C14.5 10.381 13.381 11.5 12 11.5Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinLocationIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinLocationIcon;
